// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 站内消息分页 GET /api/sys_notification/list */
export async function getNotificationList(
  params: { current?: number; pageSize?: number },
  options?: { [key: string]: any },
) {
  return request<API.PagingResponse<SysNotificationAPI.NotificationItem>>(
    '/api/sys_notification/list',
    { method: 'GET', params, ...(options || {}) },
  );
}

/** 未读消息数 GET /api/sys_notification/unread_count */
export async function getNotificationUnreadCount(options?: { [key: string]: any }) {
  return request<API.Response<number>>('/api/sys_notification/unread_count', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 标记已读（ids 为空=全部已读） PUT /api/sys_notification/read */
export async function markNotificationRead(
  data: SysNotificationAPI.MarkReadParams,
  options?: { [key: string]: any },
) {
  return request<API.Response<number>>('/api/sys_notification/read', {
    method: 'PUT',
    data,
    ...(options || {}),
  });
}
